var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "install-pwa" }, [
    _c(
      "div",
      { staticClass: "install-title" },
      [
        _vm.isShow
          ? _c("AutoFontSize", [_vm._v(_vm._s(_vm.$t("title_install_bonus")))])
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "div",
          { staticClass: "txt-1" },
          [
            _vm.isShow
              ? _c("AutoFontSize", [
                  _vm._v(_vm._s(_vm.$t("subtitle_install_bonus"))),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c("div", {
          staticClass: "txt-2",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("tips_install_bonus", [
                `<span>${_vm.$t("title_install_bonus")}</span>`,
              ])
            ),
          },
        }),
        _c("div", { staticClass: "award" }),
        _vm.isComplete
          ? [_c("div", { staticClass: "complete" })]
          : [
              _vm.calcShowInstall
                ? _c(
                    "div",
                    { staticClass: "btn", on: { click: _vm.goInstall } },
                    [_vm._v(_vm._s(_vm.$t("title_install_bonus")))]
                  )
                : _c("div", { staticClass: "has-install" }, [
                    _vm._v(_vm._s(_vm.$t("boon-browser-forbidden"))),
                  ]),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }